import React from 'react';
import { Footer } from '../../containers'
import { PageHeader } from '../../components';

function NotFound({ data }) {
  return (<div className='pageBody'>
      <PageHeader Brand={data.Brand} />
      <main>
        Page 404 Not Found !!
      </main>
      <Footer  data={data.Footer} brand={data.Brand}/>
  </div>);
}

export default NotFound;
